import React from "react";
import { Nav, Logo, Bars, NavMenu, NavBtn, MenuText } from "./HeaderElements";
import logoPic from "../../Assets/logo.png";
import myCv from "../../Assets/YobahJohnCV2026.pdf";
const Header = ({ toggle }) => {
  return (
    <Nav>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1rem 3rem', position: 'relative', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Logo to="/">
          <img
            src={logoPic}
            alt="logo"

          />
        </Logo>
        <NavMenu>
          {/* Navigation links moved to dropdown menu only */}
        </NavMenu>
        <NavBtn>
          <a
            className="btn PrimaryBtn"
            href={myCv}
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
        </NavBtn>
        <Bars onClick={toggle} />
        <MenuText onClick={toggle}>
          <span>☰ Menu</span>
        </MenuText>
      </div>
    </Nav>
  );
};

export default Header;
